export default {"src":"/_next/static/media/data.6564e645.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};